"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactCountdown = _interopRequireDefault(require("react-countdown"));
var _reactI18next = require("react-i18next");
var _ui = require("../../../ui");
var _excluded = ["afterTimeoutClick", "onComplete", "onClick", "onTick", "children", "loading", "disabled", "timeout", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SubmitButton = function SubmitButton(_ref) {
  var afterTimeoutClick = _ref.afterTimeoutClick,
    _onComplete = _ref.onComplete,
    _onClick = _ref.onClick,
    _onTick = _ref.onTick,
    children = _ref.children,
    loading = _ref.loading,
    disabled = _ref.disabled,
    timeout = _ref.timeout,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Button, _extends({
    wide: true,
    type: "button",
    color: "secondary",
    loading: loading,
    disabled: disabled,
    onClick: function onClick() {
      if (!timeout) {
        afterTimeoutClick && afterTimeoutClick();
      } else {
        _onClick && _onClick();
      }
    },
    className: className
  }, props), children, timeout !== 0 && !loading && /*#__PURE__*/_react.default.createElement(_reactCountdown.default, {
    controlled: false,
    onTick: function onTick(props) {
      if (_onTick) _onTick(props.total);
    },
    onComplete: function onComplete() {
      if (_onComplete) _onComplete();
    },
    date: Date.now() + timeout,
    renderer: function renderer(_ref2) {
      var seconds = _ref2.seconds;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', /*#__PURE__*/_react.default.createElement(_ui.CountdownTime, {
        seconds: seconds,
        options: {
          shortFormat: true
        }
      }));
    }
  }));
};
exports.SubmitButton = SubmitButton;